export const SortOrder = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type SortOrderValue = (typeof SortOrder)[keyof typeof SortOrder];

/** Lowercase sort direction used by react-data-table-component. */
export const TableSort = {
  ASC: "asc",
  DESC: "desc",
} as const;

export type TableSortValue = (typeof TableSort)[keyof typeof TableSort];

export const toSortOrderValue = (direction: TableSortValue): SortOrderValue =>
  direction.toUpperCase() as SortOrderValue;
